import classNames from 'classnames';
import Card from 'src/components/form/search/cards/card';
import css from './vacancy.module.scss';
import Complaint from 'src/pages/complaint/complaint';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';
import { Link } from 'react-router-dom';
import { VacancyModel } from 'src/types';
import { WORK_SEARCH } from 'src/constants/routes';

interface VacancyProps {
  vacancy: VacancyModel;
  onClick: () => void;
}

export default function Vacancy({ vacancy, onClick }: Readonly<VacancyProps>) {
  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <Card
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={css.vacancy}
      onClick={onClick}
      hoverBorder='left'>
      {complaint}
      <Link to={`${WORK_SEARCH.path}/vacancy/${vacancy.slug}`} className={css.textContainer} id={vacancy.id}>
        <div className={css.unitImg}>
          <img src={vacancy.unitImg ?? vacancy.branchImg} alt={vacancy.unitImg} />
        </div>
        <div className={css.details}>
          <div className={classNames(css.textGroup, css.titleGroup)}>
            <span className={css.title}>{vacancy.name}</span>
          </div>
          <div className={css.logoFooter}>
            <img src={vacancy.branchImg} alt={vacancy.branchName} />
            <p>{vacancy.unitName}</p>
          </div>
        </div>
      </Link>
    </Card>
  );

  return (
    <Complaint
      key={vacancy.id}
      entityId={vacancy.id}
      entityType={ComplaintEntityType.VACANCY}
      targetTitle={`${vacancy.name} ${vacancy.unitName}`}
      alignRight={true}
      wrapper={wrapper}
    />
  );
}
